import styled from 'styled-components';

export const Container = styled.div`
    height: 100%;
    width: 100%;
}
`;

export const SelectIntentArea = styled.div`
    margin-top: 10px;
    width: 100%;
}
`;

export const SubmitButtonArea = styled.div`
width: 100%;
margin-top: 10px;
> button {
   width:100%;
}
}
`;
